import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { type FleetSummary as Summary, SlotStatus } from '@/models/vault'
import { rollupLabel, statusStyle } from './slotStatus'

function plural(count: number, noun: string) {
  return `${count} ${noun}${count === 1 ? '' : 's'}`
}

/** The whole fleet in one row: the carrier's file, every driver's and every vehicle's, tallied by status. */
export function FleetSummary({ summary, action }: { summary: Summary; action?: ReactNode }) {
  return (
    <div className="flex flex-wrap items-center gap-x-6 gap-y-2 pt-6 pb-1">
      <div className="flex items-center gap-3">
        <span className="text-lg font-semibold">Vault documents</span>
        <span className="text-muted-foreground text-sm whitespace-nowrap">
          {plural(summary.total, 'file')}
        </span>
      </div>
      <dl
        aria-label="Files by status"
        className="flex flex-wrap items-baseline gap-x-5 gap-y-1 text-sm sm:ml-auto"
      >
        {/* Expiring and expired are counted on the expiry timeline card; what is left is what never arrived. */}
        <div className="flex items-baseline gap-1.5">
          <dd
            className={cn(
              'text-base font-semibold',
              summary.byStatus[SlotStatus.MISSING] > 0
                ? statusStyle(SlotStatus.MISSING).text
                : 'text-muted-foreground'
            )}
          >
            {summary.byStatus[SlotStatus.MISSING]}
          </dd>
          <dt className="text-muted-foreground">{rollupLabel(SlotStatus.MISSING)}</dt>
        </div>
      </dl>
      {action}
    </div>
  )
}
